export default __webpack_public_path__ + "static/media/stat-21-partners.e8008e57.svg";